import { useCallback } from 'react';

export const usePadStart = () => {
  const padStart = useCallback((value: number) => {
    if (typeof value !== 'number') {
      return '';
    }

    if (value === 0) {
      return '00';
    }

    return value.toString().padStart(2, '0');
  }, []);

  return { padStart };
};
